import { createContext } from "react";

const BookContext = createContext();

export default BookContext;
